import { makeANumber } from "../../utils/makeANumber";

export const maxStep = (record: Record<number, any>): number => {
    return Math.max(...Object.keys(record).map(t => makeANumber(t)));
}
